import { parseDelimited, type Row } from './importer';

/**
 * Reads a squad list from whatever the coach actually has.
 *
 * SheetJS is loaded on demand: it is ~400KB and only matters when someone drops
 * an .xlsx, so it must not sit in the main bundle that loads pitch-side.
 */
export async function readSpreadsheetFile(file: File): Promise<Row[]> {
  const name = file.name.toLowerCase();

  if (/\.(csv|tsv|txt)$/.test(name)) {
    return parseDelimited(await file.text());
  }

  if (/\.(xlsx|xlsm|xls|ods)$/.test(name)) {
    const XLSX = await import('xlsx');
    const workbook = XLSX.read(await file.arrayBuffer(), { type: 'array' });
    const first = workbook.SheetNames[0];
    if (!first) return [];
    const sheet = workbook.Sheets[first];
    if (!sheet) return [];
    // header:1 gives raw rows rather than objects keyed by a guessed header,
    // because the header may not be on the first line. raw:false formats dates
    // and numbers as the coach sees them in the file.
    return XLSX.utils.sheet_to_json<Row>(sheet, { header: 1, raw: false, defval: '' });
  }

  // Unknown extension: try to read it as text rather than refusing outright.
  return parseDelimited(await file.text());
}
